import { useGeneralStore } from '@core/stores/general'
import { applyWebConfig } from '~/utils/web-config'

// Tenant settings and menus (generalStore.webConfig) for the header, footer, <head> and home
// page. Loaded during the server render and handed to the browser with the Pinia state; only
// pages rendered in the browser alone (routeRules ssr: false) load it client-side.
export default defineNuxtPlugin(async (nuxtApp) => {
    const loaded = useState('web-config-loaded', () => false)
    if (loaded.value) return

    const res = await nuxtApp.$api.get('/public/web-config')
    applyWebConfig(useGeneralStore().webConfig, res.data)

    loaded.value = true
})
